import React from 'react';

import LinkButton from '@core/components/linkbutton/LinkButton';

import EditIcon from 'assets/icons/edit-icon-filled.svg?url';
import { Verify } from 'iconsax-react';

import classes from './Skills.module.scss';
import ActionButton from '@core/components/actionbutton/ActionButton';
const Skills = ({ data, refetchMyResume, hasEditButton = false, editClickHandler, isNewStep = true }) => {
    return (
        <>
            {((data && (data.software_skills !== null || data.technical_skills !== null)) || isNewStep) && (
                <section className={`d-flex flex-column gap-2 ${classes['skills-wrapper']}`}>
                    <div
                        className={`d-flex flex-row justify-content-between ${classes['skills-title']}`}>
                        <div className='d-flex align-items-center gap-2 ms-4'>
                            <Verify />
                            <h4 className="d-none d-md-block">Skills</h4>
                        </div>
                        <div className="d-flex gap-1">
                            {hasEditButton && (
                                <ActionButton kind="simple" onClick={() => editClickHandler('skill')}>
                                    <img src={EditIcon} alt="edit-icon" />
                                </ActionButton>
                            )}
                        </div>
                    </div>
                    <div className={`d-flex flex-column gap-4 ${classes['skills-content']}`}>
                        {data && data.software_skills !== null && (
                            <div
                                className={`d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center ${classes['skills-card']}`}>
                                <div className="d-flex flex-column gap-2 order-2 order-md-1">
                                    <h6>Software Skills</h6>
                                    <p>{data.software_skills}</p>
                                </div>
                            </div>
                        )}
                        {data && data.technical_skills !== null && (
                            <div
                                className={`d-flex flex-column flex-md-row justify-content-between align-items-baseline align-items-md-center ${classes['skills-card']}`}>
                                <div className="d-flex flex-column gap-2 order-2 order-md-1">
                                    <h6>Technical Skills</h6>
                                    <p>{data.technical_skills}</p>
                                </div>
                            </div>
                        )}



                    </div>
                </section>
            )}
        </>
    );
};

export default Skills;